import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Apply from "@/components/Apply";
import Footer from "@/components/Footer";
import ApplyModal from "@/components/ApplyModal";
import BrandList from "@/components/BrandList";
import haiboLong from "@/images/cooperative_delivery.png";

const saasFlowPath = [
  {
    icon: "copperation_icon",
    title: "合作洽谈",
  },
  {
    icon: "programme_icon",
    title: "方案确认",
  },
  {
    icon: "contract_icon",
    title: "合同签约",
  },
  {
    icon: "system_icon",
    title: "系统对接",
  },
  {
    icon: "online_icon",
    title: "上线发单",
  },
];

const HiboTian = () => {
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // 跳转后滚动到顶部
  }, []);

  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <div className="hibo_tian_wrapper">
      <ApplyModal isShow={showModal} onCancel={onCancel} />
      {showImageModal && (
        <div className="campus_recruit_mask" onClick={() => setShowImageModal(false)}>
          <img
            className="campus_recruit_img"
            src={require(`@/images/haibao.png`)}
            alt="招募校园商"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      <div className="carousel_wrapper_front">
        <img
          style={{ width: "100%" }}
          src={`https://static.hiboos.com/static/yzt-home/homePage/hibo-tian.webp`}
          alt=""
        />
        <div className="opt_btn_wrapper">
          <div
            className="opt_btn"
            onClick={() => {
              window.open("https://www.wjx.cn/vm/rCxPLUH.aspx#", "_blank");
              setDjMs("func_business_brand_enter-web", "商家品牌入驻");
            }}
          >
            点击入驻
          </div>
          <div
            className="service_business"
            onClick={() => {
              navigate("/service-business");
            }}
          >
            <span>配送商合作</span>
            <img
              width={14}
              height={8}
              src={require(`@/images/frontWarehouse/about_arrow.png`)}
              alt=""
            />
          </div>
          <div
            className="campus_recruit_btn"
            onClick={() => {
              setShowImageModal(true);
            }}
          >
            <span>招募校园商</span>
          </div>
        </div>
      </div>
      <div className="saas_flow_path">
        <p className="title_big">诚邀商家品牌、餐饮/零售SaaS接入</p>
        <div className="card_wrapper">
          {saasFlowPath.map((item, index) => {
            return (
              <div key={index} className="card_item">
                <div className="card">
                  <img
                    className="icon"
                    src={`https://static.hiboos.com/static/yzt-home/hiboTian/${item.icon}.png`}
                    alt=""
                  />
                  <p className="title">{item.title}</p>
                </div>
                <img
                  className="right_arrow"
                  width={19}
                  height={76}
                  src={`https://static.hiboos.com/static/yzt-home/hiboTian/right_arrow.png`}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* 产品亮点 */}
      <div className="product_points">
        <img
          height={644}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/product_points_bg.png`}
          alt=""
        />
      </div>
      {/* 全运力品牌覆盖 */}
      <div className="delivery_brand">
        <img
          height={524}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/delivery_brand_bg.png`}
          alt=""
        />
      </div>
      {/* 全业态解决方案 */}
      <div className="Rx">
        <img
          height={524}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/Rx_bg.png`}
          alt=""
        />
      </div>
      {/* 强大系统承载能力 */}
      <div className="system_load">
        <img
          height={524}
          src={`https://static.hiboos.com/static/yzt-home/hiboTian/system_load_bg.png`}
          alt=""
        />
      </div>

      <div className="cooperative_delivery">
        <p className="title_big" style={{ marginBottom: "50px" }}>
          合作运力
        </p>
        <BrandList imgsrc={haiboLong} styles={{ width: "1584px" }} />
      </div>
      <Apply />
      <Footer />
    </div>
  );
};
export default HiboTian;
